import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { emitter } from '../../events/bridge-events-emitter';

/**
 * Expected shape of the main process in Electron contexts.
 */

/**
 * Expected shape of events from Electron web view contexts.
 */

/**
 * A secure bridge between renderer processes and the main process, allowing the browser transport
 * to communicate with Electron's main process when content is rendered in the webview.
 */

/**
 * Global type augmentation for the window object to include the Electron bridge API.
 */

/**
 * Utility to check if the current environment is an Electron renderer process.
 *
 * @description Safely checks for the presence of the webviewAPI and verifies
 * it's actually an Electron environment by calling the isElectron method.
 *
 * @returns true if running in Electron renderer, false otherwise
 */
export var isWebviewContext = function isWebviewContext() {
  try {
    return Boolean(typeof window !== 'undefined' && window.webviewAPI && typeof window.webviewAPI.isElectron === 'function' && window.webviewAPI.isElectron());
  } catch (_unused) {
    return false;
  }
};

/**
 * Utility to safely access the Electron bridge API.
 *
 * @description Provides a type-safe way to access the webviewAPI with proper error handling.
 *
 * @returns The webviewAPI if available, undefined otherwise
 */
export var getWebviewAPI = function getWebviewAPI() {
  try {
    if (isWebviewContext()) {
      return window.webviewAPI;
    }
    return undefined;
  } catch (_unused2) {
    return undefined;
  }
};

/**
 * Send message to Electron main process via exposed API.
 *
 * @description Centralized function for sending RPC messages from renderer to main process.
 * Handles error cases and emits appropriate transport events.
 *
 * @param message The RPC message to send
 * @param transportSource The source identifier for the transport
 * @returns void
 */
export var sendToMainProcess = function sendToMainProcess(message, transportSource) {
  var electronAPI = getWebviewAPI();
  if (!electronAPI) {
    emitter().emit({
      type: 'transport-error',
      transportType: transportSource,
      direction: 'outbound',
      messageId: message.id,
      error: {
        message: 'Webview API not available',
        code: 'WEBVIEW_API_UNAVAILABLE'
      }
    });
    return;
  }
  var envelope = {
    version: 1,
    source: transportSource,
    message: message
  };
  emitter().emit({
    type: 'transport-message-sent',
    transportType: transportSource,
    direction: 'outbound',
    messageId: message.id,
    message: _objectSpread({}, envelope)
  });

  // use the exposed to send to main
  electronAPI.postMessageToMain(envelope);
};

/**
 * The IPC channel name used for bridge communication
 */
export var IPC_CHANNEL = 'rovo-bridge-message-channel';

/**
 * An identifier for the `electron` main process.
 */
export var DESKTOP_INSTANCE_ID = 'desktop-main';